import { Clock } from "lucide-react";

export default function ComingSoonPage({ title, description, phase, testId }) {
  return (
    <div
      data-testid={testId || "coming-soon"}
      className="bg-white rounded-2xl border border-[#D4C4A8]/40 shadow-sm p-10 lg:p-14 text-center"
    >
      <div className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-[#F3F1EB] text-[#3A4A38] mb-4">
        <Clock size={24} />
      </div>
      <h2 className="text-2xl font-semibold text-[#2C2C2C] mb-2">{title}</h2>
      <p className="text-sm text-[#2C2C2C]/60 max-w-md mx-auto">{description}</p>
      {phase && (
        <p className="mt-6 inline-block text-xs px-3 py-1 rounded-full bg-[#3A4A38] text-white">
          {phase}
        </p>
      )}
    </div>
  );
}
